import { render } from "./control-overlay.vue?vue&type=template&id=58e95842"
const script = {}

import "./control-overlay.vue?vue&type=style&index=0&id=58e95842&lang=scss"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__